// src/components/SessionExpiryWarning.jsx
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTokenExpiry } from './hooks/useTokenExpiry';
import { logout } from './redux/Slices/authSlice';

const SessionExpiryWarning = () => {
  const dispatch = useDispatch();
  const { timeRemaining, formatTimeRemaining, isExpired } = useTokenExpiry();
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    if (timeRemaining !== null && timeRemaining <= 300000) { // 5 minutes warning
      setShowWarning(true);
    } else {
      setShowWarning(false);
    }
  }, [timeRemaining]);

  if (isExpired) {
    dispatch(logout());
    return null;
  }

  if (!showWarning || !timeRemaining) return null;

  return (
    <div className="session-warning">
      <div className="session-warning__content">
        <span>⚠️ Your session will expire in {formatTimeRemaining()}</span>
        <button onClick={() => window.location.reload()}>Stay Logged In</button>
      </div>
      <style jsx>{`
        .session-warning {
          position: fixed;
          bottom: 20px;
          right: 20px;
          background: #fff3cd;
          border: 1px solid #ffc107;
          border-radius: 8px;
          padding: 12px 20px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          z-index: 9999;
          max-width: 400px;
        }
        .session-warning__content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
        }
        .session-warning__content button {
          background: #ffc107;
          border: none;
          padding: 6px 16px;
          border-radius: 4px;
          font-weight: 600;
          cursor: pointer;
        }
        .session-warning__content button:hover {
          background: #ffb300;
        }
        @media (max-width: 768px) {
          .session-warning {
            bottom: 10px;
            right: 10px;
            left: 10px;
            max-width: none;
          }
          .session-warning__content {
            flex-direction: column;
            text-align: center;
          }
        }
      `}</style>
    </div>
  );
};

export default SessionExpiryWarning;